export const uses = [
  {
    img: "container.svg",
    name: "مهاجرت با بهینه‌سازی پلتفرم (Replatform)",
    desc: "در این روش، با حداقل تغییرات در کد، سرویس‌ها به زیرساخت ابری منتقل می‌شوند و برخی به‌روز‌رسانی‌ها برای بهره‌گیری از قابلیت‌های ابری اعمال می‌شود. این رویکرد، تعادل مناسبی بین سرعت مهاجرت و بهره‌مندی از مزایای ابر فراهم می‌کند.",
    alt: "مهاجرت با بهینه‌سازی پلتفرم (Replatform)",
    title: "مهاجرت با بهینه‌سازی پلتفرم (Replatform)",
  },
  {
    img: "Isolation.svg",
    name: "مهاجرت بین ابرها (Cloud-to-Cloud Migration)",
    desc: "در این نوع مهاجرت، منابع از یک ا‌رائه‌دهنده خدمات ابری به دیگری برای بهره‌مندی از قابلیت‌های فنی بهتر یا در پی ادغام زیرساخت‌ها، منتقل می‌شوند. این نوع استقرار ابری به سازمان‌ها کمک می‌کند تا در پلتفرم مناسب‌تری، سرویس‌های خود را پایدارتر و مقرون‌به‌صرفه‌تر اجرا کنند.",
    alt: "مهاجرت بین ابرها (Cloud-to-Cloud Migration)",
    title: "مهاجرت بین ابرها (Cloud-to-Cloud Migration)",
  },
  {
    img: "plans.svg",
    name: "مهاجرت دیتاسنتر سنتی به زیرساخت ابری (Lift and Shift)",
    desc: "در این روش رایج، منابع سازمان از دیتاسنتر فیزیکی بدون تغییر در کد یا معماری، مستقیماً به زیرساخت ابری منتقل می‌شوند. این روش رویکردی سریع و کم‌ریسک برای حذف هزینه‌های نگه‌داری سرورهای فیزیکی و افزایش دسترس‌پذیری سرویس‌ها است.",
    alt: "مهاجرت دیتاسنتر سنتی به زیرساخت ابری (Lift and Shift)",
    title: "مهاجرت دیتاسنتر سنتی به زیرساخت ابری (Lift and Shift)",
  },
  {
    img: "HA.svg",
    name: "مهاجرت با بازطراحی معماری (Refactor)",
    desc: "در این مدل، برنامه‌ها به‌طور کامل بازطراحی می‌شوند تا با معماری ابر-بومی (Cloud-Native) سازگار شوند. این رویکرد، بیشترین بهره‌وری از قابلیت‌های ابری را فراهم می‌کند، اما نیازمند زمان و منابع بیشتری است.",
    alt: "مهاجرت با بازطراحی معماری (Refactor)",
    title: "مهاجرت با بازطراحی معماری (Refactor)",
  },
  {
    img: "service.svg",
    name: "مهاجرت به معماری ابری ترکیبی (Hybrid cloud migration)",
    desc: "در این مدل، بخشی از زیرساخت سازمان به ابر منتقل می‌شود و بخشی دیگر در محل باقی می‌ماند. این رویکرد، ضمن حفظ سرمایه‌گذاری‌های قبلی، امکان تطابق با الزامات نظارتی را فراهم کرده  و قابلیت‌هایی مانند بازیابی از بحران و بکاپ ابری را پس از مهاجرت مهیا می‌سازد.",
    alt: "مهاجرت به معماری ابری ترکیبی (Hybrid cloud migration)",
    title: "مهاجرت به معماری ابری ترکیبی (Hybrid cloud migration)",
  },
];

export const serviceFeatures = [
  {
    title: "کاهش هزینه‌های زیرساخت و نگه‌داری",
    desc: "کاهش هزینه‌های سرمایه‌ای و عملیاتی با حذف تجهیزات فیزیکی، ساده‌سازی مدیریت زیرساخت و بهینه‌سازی مصرف منابع بر اساس نیاز واقعی سازمان",
    logo: "Feature-1.svg",
    imgAlt: "کاهش هزینه‌های زیرساخت و نگه‌داری",
    imgTitle: "کاهش هزینه‌های زیرساخت و نگه‌داری",
  },
  {
    title: "رشد مقیاس‌پذیر و منعطف در تخصیص منابع",
    desc: "دسترسی آنی به منابع محاسباتی با امکان افزایش یا کاهش ظرفیت‌ها بر اساس نیاز لحظه‌ای، مناسب برای کسب‌وکارهای با رشد متغیر یا نیاز به مقیاس‌پذیری سریع",
    logo: "Feature-5.svg",
    imgAlt: "رشد مقیاس‌پذیر و منعطف در تخصیص منابع",
    imgTitle: "رشد مقیاس‌پذیر و منعطف در تخصیص منابع",
  },
  {
    title: "زیرساخت امن و منطبق با الزامات قانونی",
    desc: "استفاده از بسترهای دارای استانداردهای امنیتی برای داده‌ها، به‌همراه قابلیت انطباق با الزامات نهادهای قانونی و ناظر مانند سازمان پدافند غیرعامل",
    logo: "Feature-6.svg",
    imgAlt: "زیرساخت امن و منطبق با الزامات قانونی",
    imgTitle: "زیرساخت امن و منطبق با الزامات قانونی",
  },
  {
    title: "تداوم کسب‌وکار و بازیابی در شرایط بحران",
    desc: "برخورداری از راهکارهای HA، بکاپ منظم و بازیابی از بحران (DR)، با حداقل اختلال در سرویس‌دهی و تضمین پایداری عملیات حیاتی سازمان",
    logo: "Feature-3.svg",
    imgAlt: "تداوم کسب‌وکار و بازیابی در شرایط بحران",
    imgTitle: "تداوم کسب‌وکار و بازیابی در شرایط بحران",
  },
  {
    title: "پشتیبانی از فناوری‌های نوین مانند هوش مصنوعی و کلان‌داده",
    desc: "فراهم آوردن بستری مناسب با منابع محاسباتی قدرتمند و مقیاس‌پذیر برای اجرای پروژه‌های بزرگ مبتنی بر هوش مصنوعی و تحلیل کلان‌داده در زیرساخت‌های ابری",
    logo: "Feature-2.svg",
    imgAlt: "پشتیبانی از فناوری‌های نوین مانند هوش مصنوعی و کلان‌داده",
    imgTitle: "پشتیبانی از فناوری‌های نوین مانند هوش مصنوعی و کلان‌داده",
  },
  {
    title: "توسعه سریع‌تر و استقرار مداوم سرویس‌ها",
    desc: "تسریع فرآیند‌های توسعه و به‌روزرسانی سرویس‌ها و کاهش زمان عرضه محصولات به بازار با بهره‌گیری از راهکار DevOps و ابزارهای CI/CD در زیرساخت‌های ابری",
    logo: "Feature-7.svg",
    imgAlt: "توسعه سریع‌تر و استقرار مداوم سرویس‌ها",
    imgTitle: "توسعه سریع‌تر و استقرار مداوم سرویس‌ها",
  },
  {
    title: "آمادگی برای کار ترکیبی و دورکاری",
    desc: "ارائه دسترسی ایمن از راه دور  روی زیرساخت‌های ابری  به تیم‌های توزیع‌شده سازمان در بخش‌های مختلف جغرافیایی برای افزایش بهره‌وری و امکان فعالیت شناور",
    logo: "Feature-8.svg",
    imgAlt: "آمادگی برای کار ترکیبی و دورکاری",
    imgTitle: "آمادگی برای کار ترکیبی و دورکاری",
  },
  {
    title: "کاهش نیروی متخصص داخلی",
    desc: "مدیریت و نگه‌داری سرورها و منابع در زیرساخت ابری توسط ارائه‌دهنده خدمات ابری در جهت کاهش جذب و هزینه‌های نگه‌داشت نیروی فنی متخصص توسط سازمان‌ها",
    logo: "Feature-4.svg",
    imgAlt: "کاهش نیروی متخصص داخلی",
    imgTitle: "کاهش نیروی متخصص داخلی",
  },
];

export const steps = [
  {
    title: "۱. تحلیل و شناخت زیرساخت موجود",
    desc: "زیرساخت فعلی، بارهای کاری، الزامات امنیتی و محدودیت‌های فنی سازمان به‌صورت کامل بررسی می‌شود؛ تا شناخت دقیقی از وضعیت موجود برای طراحی مسیر مهاجرت بدست آید.",
    logo: "centralized.svg",
    imgAlt: "۱. تحلیل و شناخت زیرساخت موجود",
    imgTitle: "۱. تحلیل و شناخت زیرساخت موجود",
  },
  {
    title: "۲. طراحی نقشه راه اختصاصی",
    desc: "تیم فنی آبالون یک برنامه مهاجرت ابری متناسب با نیازهای سازمان تدوین می‌کند که شامل فازبندی، تعیین اولویت سرویس‌ها، زمان‌بندی و ملاحظات ریسک است.",
    logo: "enterprise.svg",
    imgAlt: "۲. طراحی نقشه راه اختصاصی",
    imgTitle: "۲. طراحی نقشه راه اختصاصی",
  },
  {
    title: "۳. اجرای کنترل‌شده و مرحله‌ای",
    desc: "مهاجرت ابری به‌صورت تدریجی و با کمترین اختلال در سرویس‌های جاری انجام می‌شود. در استقرار ابری، عملکرد هر بخش پایش می‌شود تا منابع به‌صورت بهینه تخصیص یابند.",
    logo: "monitor.svg",
    imgAlt: "۳. اجرای کنترل‌شده و مرحله‌ای",
    imgTitle: "۳. اجرای کنترل‌شده و مرحله‌ای",
  },
  {
    title: "۴. پشتیبانی پس از مهاجرت",
    desc: "پس از استقرار ابری، خدمات مانیتورینگ، پشتیبانی و بهینه‌سازی منابع ابری ادامه دارد تا سازمان بتواند حداکثر بهره‌وری و امنیت را در زیرساخت جدید تجربه کند.",
    logo: "configuration.svg",
    imgAlt: "۴. پشتیبانی پس از مهاجرت",
    imgTitle: "۴. پشتیبانی پس از مهاجرت",
  },
];

export const customers = [
  {
    title: "پیام‌رسان ایتا",
    logo: "eita.svg",
    imgAlt: "پیام‌رسان ایتا",
    imgTitle: "پیام‌رسان ایتا",
  },
  {
    title: "هلال احمر",
    logo: "helal-ahmar-iran.svg",
    imgAlt: "هلال احمر",
    imgTitle: "هلال احمر",
  },
  {
    title: "دیتاک",
    logo: "dataak.svg",
    imgAlt: "دیتاک",
    imgTitle: "دیتاک",
  },
];

export const statsData = [
  {
    title: "تا ۳۱٪ صرفه‌جویی",
    cap: "در هزینه‌های زیرساختی با حذف هزینه‌های مدیریت سرورها و تجهیزات و راهکارهای ابری",
  },
  {
    title: "تا ۶۲٪ افزایش بهره‌وری",
    cap: "در عملکرد تیم IT با حذف وظایف نگه‌داری سنتی در کنار خودکارسازی عملیات زیرساخت و استقرار ابری",
  },
  {
    title: "تا ۴۳٪ کاهش رخدادهای امنیتی",
    cap: "استفاده از ابزارهای پیشرفته امنیتی ابری مانند رمزنگاری، مانیتورینگ بلادرنگ، WAF و PAM ابری",
  },
  {
    title: "تا ۳ برابر افزایش سرعت عرضه محصول",
    cap: "پیاده‌سازی سریع‌تر ویژگی‌های جدید یا محصولات در محیط‌های تست و توسعه ابری با کمک راهکارهای DevOps و ابزار CI/CD",
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری امکانات یک دیتاسنتر فیزیکی قوی را روی ابرها فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌‌ترین نیازهای سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "VPS-Service.svg",
    route: "/dedicated-server",
  },
  {
    title: "سرویس کولوکیشن",
    desc: "با سرویس کولوکیشن آبالون، بدون دغدغه تامین برق، کولینگ و پهنای باند، سرورهای سازمان شما در محیطی ایمن، با اتصال مستقیم به شبکه‌ای پرسرعت میزبانی می‌شوند.",
    logo: "ManagedService-Service.svg",
    route: "/colocation",
  },
];

export const questions = [
  {
    title:
      "آیا برای مهاجرت ابری نیاز به بازنویسی کامل نرم‌افزارهای فعلی وجود دارد؟",
    answer:
      "عمده مدل‌های مهاجرت نیازی به بازنویسی کامل نرم‌افزارها را ندارد و بسته به مدل مهاجرت انتخابی، می‌توان دیتاسنتر با معماری سنتی یا ابری را بدون تغییر در کد یا معماری به زیرساخت ابری منتقل کرد. در مواردی که نیاز به بهینه‌سازی یا بازطراحی (Refactor) وجود دارد، تیم فنی آبالون مسیر مناسب را طراحی و اجرا می‌کند.",
  },
  {
    title:
      "در طول فرآیند مهاجرت، چه تضمینی برای پایداری سرویس‌های جاری وجود دارد؟",
    answer:
      "مهاجرت ابری در آبالون به‌صورت مرحله‌ای و تحت نظارت کامل انجام می‌شود. با پایش مداوم عملکرد در هر فاز، اختلال در سرویس‌های حیاتی به حداقل می‌رسد و تداوم کسب‌وکار هم‌زمان با استقرار ابری تضمین می‌شود.",
  },
  {
    title: "آیا امکان استقرار ابری تنها بخشی از زیرساخت سازمان وجود دارد؟",
    answer:
      "بله. راهکار آبالون از مدل‌های مختلف مهاجرت، از جمله مهاجرت ترکیبی (Hybrid) یا مهاجرت تدریجی سرویس‌ها و پایگاه‌های داده پشتیبانی می‌کند. این انعطاف‌پذیری به سازمان اجازه می‌دهد مطابق با الزامات خود، برنامه مهاجرت را تجربه کند.",
  },
  {
    title:
      "چه سازمان‌هایی بیشترین بهره را از راهکار مهاجرت ابری آبالون می‌برند؟",
    answer:
      "سازمان‌هایی که با چالش‌هایی مانند هزینه‌های بالای نگه‌داری زیرساخت سنتی، نیاز به مقیاس‌پذیری سریع، الزامات امنیتی و یا ضرورت بازیابی در بحران مواجه هستند، می‌توانند با مهاجرت به ابر، بهره‌وری و انعطاف‌پذیری خود را به‌طور قابل‌توجهی افزایش دهند.",
  },
];
